import React from "react";

import Phone from "../../components/Phone/Phone";
import { TOLL_FREE_NUMBER } from "../../settings/settings";
import config from "../../config/config";
import styles from "../Destination/Destination.module.scss";
import { EXIT_MODAL } from "../../redux/modules/modals/modals.module";
import ModalLink from "../../components/Shared/Modal/ModalLink/ModalLink";

export const BankStatusLockMessage = ({ lockMessage }) => {
  switch (lockMessage) {
    case "lapsed":
      return (
        <span>
          Bank Expired - Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> to update
          expired bank or -
        </span>
      );
    case "verifyMicroDeposits":
      return "Bank Ready for Verification -";
    case "requiresRenewal":
      return (
        <span>
          Bank Requires Update - Call <Phone phoneNumber={TOLL_FREE_NUMBER} />{" "}
          to update bank or -
        </span>
      );
    case "preparingMicroDeposits":
      return "Pending – Preparing Micro-deposits (typically takes 2-3 days)";
    case "processing":
      return "Pending – Available on";
    case "corruptBankData":
      return (
        <span>
          Bank Renewal Required - Call <Phone phoneNumber={TOLL_FREE_NUMBER} />{" "}
          to update expired bank or
        </span>
      );
    case "bankNotAssociated":
      return (
        <span>
          <span className="emphasis">Bank Not Linked</span> - Call <Phone phoneNumber={TOLL_FREE_NUMBER} /> for
          assistance
        </span>
      );
    case "bankNotLinked":
      return (
        <span>
          <span className="emphasis">Bank Not Linked</span> -{" "}
          <ModalLink
            link={<div className={styles["error-link"]}>Link bank</div>}
            linkStyle="link"
            modalProps={{
              url: `${config.url}/usis/my-accounts/profile/linked-bank-accounts`,
            }}
            modalName={EXIT_MODAL}
          />
        </span>
      );

    default:
      return "";
  }
};
